import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuthenticator } from '@aws-amplify/ui-react';

const LandingPage = () => {
  const { user, authStatus } = useAuthenticator((context) => [context.user, context.authStatus]);
  const navigate = useNavigate();

  useEffect(() => {
    // Check if auth status is resolved and user is authenticated
    if (authStatus === 'authenticated' && user) {
      // Redirect to Pathfinder for logged-in users
      navigate('/pathfinder');
    } else if (authStatus === 'unauthenticated') {
      // Redirect to home page for non-logged-in users
      navigate('/home');
    }
    // No redirect for 'configuring' state - wait for auth to resolve
  }, [user, authStatus, navigate]);

  // Return a loading state while checking auth
  return (
    <div className="landing-loading">
      <div className="loading-spinner"></div>
      <p>Loading your experience...</p>
      <style jsx>{`
        .landing-loading {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          height: 100vh;
          width: 100vw;
        }
        .loading-spinner {
          border: 4px solid rgba(0, 0, 0, 0.1);
          border-left-color: #007BFF;
          border-radius: 50%;
          width: 40px;
          height: 40px;
          animation: spin 1s linear infinite;
          margin-bottom: 1rem;
        }
        @keyframes spin {
          to { transform: rotate(360deg); }
        }
      `}</style>
    </div>
  );
};

export default LandingPage;
